import {
    FiChevronLeft,
    FiChevronRight,
    FiChevronsLeft,
    FiChevronsRight,
} from "react-icons/fi";

import "./pagination.scss";

export default function Pagination({
    currentPage = 1,
    totalPages = 1,
    itemsPerPage = 10,
    totalItems = 0,
    onPageChange,
}) {
    const handlePrevious = () => {
        if (currentPage > 1) onPageChange(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) onPageChange(currentPage + 1);
    };

    const handleJumpForward = () => {
        const nextJump = Math.min(currentPage + 10, totalPages);
        onPageChange(nextJump);
    };

    const handleJumpBackward = () => {
        const prevJump = Math.max(currentPage - 10, 1);
        onPageChange(prevJump);
    };

    const renderPageNumbers = () => {
        const pages = [];
        const showLeftDots = currentPage > 3;
        const showRightDots = currentPage < totalPages - 2;
        const showJumpForward = currentPage + 10 < totalPages;
        const showJumpBackward = currentPage - 10 > 1;

        if (showJumpBackward) {
            pages.push(
                <button
                    key="jump-backward"
                    onClick={handleJumpBackward}
                    className="jump-button"
                    title="Jump back 10 pages"
                >
                    <FiChevronsLeft size={14} />
                </button>
            );
        }

        pages.push(
            <button
                key={1}
                onClick={() => onPageChange(1)}
                className={currentPage === 1 ? "active" : ""}
            >
                1
            </button>
        );

        if (showLeftDots) {
            pages.push(
                <span key="left-dots" className="dots">
                    ...
                </span>
            );
        }

        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <button
                    key={i}
                    onClick={() => onPageChange(i)}
                    className={currentPage === i ? "active" : ""}
                >
                    {i}
                </button>
            );
        }

        if (showRightDots) {
            pages.push(
                <span key="right-dots" className="dots">
                    ...
                </span>
            );
        }

        if (totalPages > 1) {
            pages.push(
                <button
                    key={totalPages}
                    onClick={() => onPageChange(totalPages)}
                    className={currentPage === totalPages ? "active" : ""}
                >
                    {totalPages}
                </button>
            );
        }

        if (showJumpForward) {
            pages.push(
                <button
                    key="jump-forward"
                    onClick={handleJumpForward}
                    className="jump-button"
                    title="Jump forward 10 pages"
                >
                    <FiChevronsRight size={14} />
                </button>
            );
        }

        return pages;
    };

    const safeItemsPerPage = itemsPerPage || 1;
    const safeTotalItems = totalItems || 0;

    const startItem = (currentPage - 1) * safeItemsPerPage + 1;
    const endItem = Math.min(currentPage * safeItemsPerPage, safeTotalItems);

    return (
        <div className="pagination">
            <div className="pagination-buttons">
                <button onClick={handlePrevious} disabled={currentPage === 1}>
                    <FiChevronLeft size={16} />
                </button>

                {renderPageNumbers()}

                <button
                    onClick={handleNext}
                    disabled={currentPage === totalPages}
                >
                    <FiChevronRight size={16} />
                </button>
            </div>
        </div>
    );
}
